// Generated from src/img/svg/info.svg

export const Info = (props) => {
  return (
    <svg height="16" viewBox="0 0 16 16" width="16" {...props}>
      <path d="M7.2 12h1.6V7.2H7.2ZM8 0a8 8 0 1 0 8 8 8 8 0 0 0-8-8m0 14.4A6.4 6.4 0 1 1 14.4 8 6.41 6.41 0 0 1 8 14.4m-.8-8.8h1.6V4H7.2Z" />
    </svg>
  );
};
